export function getSystemNavSections(t) {
  return [
    {
      id: 'core',
      label: t('navigation:core'),
      items: [
        { label: t('navigation:dashboard'), path: '/', icon: 'dashboard' },
        { label: t('navigation:customers'), path: '/customers', icon: 'customers', permission: 'system.customers.view' },
        { label: t('navigation:tenants'), path: '/tenants', icon: 'tenants', permission: 'system.tenants.view' },
        { label: t('navigation:new_trial_tenant'), path: '/onboarding/trial', icon: 'trial', permission: 'system.tenants.create' },
        { label: t('navigation:onboarding_intents'), path: '/onboarding-intents', icon: 'onboarding', permission: 'system.onboarding_intents.view' },
        { label: t('navigation:provisioning'), path: '/provisioning/readiness', icon: 'provisioning', permission: 'system.tenants.provision' },
        { label: t('navigation:support'), path: '/support', icon: 'support', permission: 'system.support.view' },
        {
          label: t('navigation:support_notification_settings'),
          path: '/support/notification-settings',
          icon: 'notifications',
          permission: 'system.support.view',
        },
        { label: t('navigation:notifications'), path: '/notifications', icon: 'notifications' },
      ],
    },
    {
      id: 'billing',
      label: t('navigation:billing'),
      items: [
        { label: t('navigation:billing_overview'), path: '/billing', icon: 'billing', permission: 'system.billing.view' },
        { label: t('navigation:modulePricing'), path: '/billing/module-prices', icon: 'modulePricing', permission: 'system.billing.plans.manage' },
        { label: t('navigation:invoices'), path: '/billing/invoices', icon: 'invoices', permission: 'system.billing.view' },
        { label: t('navigation:payments'), path: '/payments', icon: 'payments', permission: 'system.billing.payments.record' },
        { label: t('navigation:subscriptions'), path: '/subscriptions', icon: 'subscriptions', permission: 'system.billing.subscriptions.manage' },
        { label: t('navigation:subscription_changes'), path: '/billing/subscription-changes', icon: 'subscriptionChanges', permission: 'system.billing.subscription_changes.view' },
        { label: t('navigation:sms_usage'), path: '/billing/sms-usage', icon: 'smsUsage', permission: 'system.billing.view' },
        { label: t('navigation:permission_cleanup'), path: '/billing/permission-cleanup', icon: 'permissionCleanup', permission: 'system.billing.permission_cleanup.view' },
      ],
    },
    {
      id: 'system_admin',
      label: t('navigation:system_admin'),
      items: [
        { label: t('navigation:mafertAppModules'), path: '/system-modules/mafertapp', icon: 'mafertappModules', permission: 'system.mafertapp_modules.view' },
        { label: t('navigation:tenant_access'), path: '/tenant-access', icon: 'tenantAccess', permission: 'system.tenant_access.view' },
        { label: t('navigation:setup_wizard'), path: '/setup-wizard', icon: 'setupWizard', permission: 'system.setup_wizard.view' },
        { label: t('navigation:moduleSetupProfiles'), path: '/setup/module-profiles', icon: 'setupProfiles', permission: 'system.mafertapp_modules.view' },
        { label: t('navigation:tenant_provisioning'), path: '/tenant-provisioning', icon: 'tenantProvisioning', permission: 'system.tenant_provisioning.view' },
        { label: t('navigation:tenant_schema'), path: '/tenant-schema', icon: 'tenantSchema', permission: 'system.tenant_schema.view' },
        { label: t('navigation:stripe'), path: '/stripe', icon: 'stripe', permission: 'system.stripe.view' },
        { label: t('navigation:external_providers'), path: '/external-providers', icon: 'externalProviders', permission: 'system.providers.view' },
        { label: t('navigation:provider_health'), path: '/external-provider-health', icon: 'providerHealth', permission: 'system.providers.view' },
      ],
    },
    {
      id: 'internal_tools',
      label: t('navigation:internalTools'),
      internalOnly: true,
      items: [
        { label: t('navigation:technicalFeatureModules'), path: '/features/modules', icon: 'featureModules', permission: 'system.features.view', internalOnly: true },
        { label: t('navigation:technicalFeatures'), path: '/features', icon: 'features', permission: 'system.features.view', internalOnly: true },
        { label: t('navigation:entitlement_evaluations'), path: '/entitlements/evaluations', icon: 'entitlements', permission: 'system.entitlements.view', internalOnly: true },
        { label: t('navigation:notification_templates'), path: '/notification-templates', icon: 'notificationTemplates', permission: 'system.notifications.view', internalOnly: true },
      ],
    },
    {
      id: 'data_lifecycle',
      label: t('navigation:dataLifecycle'),
      internalOnly: true,
      items: [
        { label: t('navigation:recycle_bin'), path: '/data-lifecycle/recycle-bin', icon: 'recycleBin', permission: 'system.data_lifecycle.view', internalOnly: true },
        { label: t('navigation:lifecycle_events'), path: '/data-lifecycle/events', icon: 'lifecycleEvents', permission: 'system.data_lifecycle.view', internalOnly: true },
        { label: t('navigation:purge_jobs'), path: '/data-lifecycle/purge-jobs', icon: 'purgeJobs', permission: 'system.data_lifecycle.view', internalOnly: true },
        { label: t('navigation:retention_policies'), path: '/data-lifecycle/retention-policies', icon: 'retentionPolicies', permission: 'system.data_lifecycle.view', internalOnly: true },
      ],
    },
  ];
}
